const nlWieZijnWij = {
  seo: {
    title: "Over ons | Ramen Repair Eindhoven — Kozijnspecialist",
    description: "Maak kennis met Ramen Repair Eindhoven: lokale specialist in kozijn-, raam- en schuifpuireparatie. 10 jaar garantie. Bel 040 798 7470.",
  },
  breadcrumb: {
    home: "Home",
    current: "Over ons",
  },
  hero: {
    pill: "OVER ONS",
    h1: "Wie zijn wij?",
    subhead: "Uw lokale specialist in kozijn-, raam- en schuifpuireparatie. Eigen monteurs uit Brabant, eerlijke prijzen en 10 jaar schriftelijke garantie.",
    ctaPrimary: "Gratis offerte",
    ctaPhone: "040 798 7470",
  },
  onsVerhaal: {
    h2: "Ons verhaal",
    p1: "Ramen Repair Eindhoven is een lokaal bedrijf met meerdere jaren ervaring in het herstellen van kozijnen, ramen, schuifpuien en deuren in PVC, aluminium en hout. Wij werken in heel Eindhoven en omstreken — voor particulieren én bedrijven.",
    p2: "Wij weten hoe vervelend een defect raam of een vastgelopen schuifpui kan zijn. Daarom maken wij snelheid en duidelijkheid tot onze prioriteit: bereikbaar 7 dagen per week, vaak binnen 48 uur ter plaatse, en altijd een eerlijke offerte op papier voordat wij beginnen.",
    p3: "Onze monteurs zijn opgeleid voor elk type kozijn en beslag — Roto, Winkhaus, Maco, Sobinco. Wij geloven in herstellen in plaats van vervangen: het is duurzamer, goedkoper en uw bestaande kozijn gaat zo weer jaren mee.",
  },
  onzeWaarden: {
    h2: "Onze waarden",
    cards: [
      { title: "Snelle reactie", desc: "Al uw offerteaanvragen worden binnen 24 uur behandeld door ons team. Bel of mail, wij reageren altijd snel.", icon: "ri-time-line" },
      { title: "10 jaar garantie", desc: "Op alle uitgevoerde herstellingen geven wij 10 jaar schriftelijke garantie. Zwart op wit bij de factuur.", icon: "ri-shield-check-line" },
      { title: "Snel ter plaatse", desc: "Onze monteurs zijn vaak binnen 48 uur bij u — voor spoedreparaties zoals inbraakschade nog sneller, soms al binnen 2 uur.", icon: "ri-map-pin-2-line" },
      { title: "Klantgericht team", desc: "Wij staan bekend om onze flexibiliteit en open communicatie. Heldere uitleg, geen onverwachte kosten.", icon: "ri-user-smile-line" },
      { title: "Geen voorrijkosten", desc: "Bij ons rekenen wij geen voorrijkosten in Eindhoven en directe omstreken. De diagnose ter plaatse is altijd gratis.", icon: "ri-car-line" },
      { title: "Eenvoudig betalen", desc: "U kunt bij ons betalen via pin, contant of overschrijving. Voor zakelijke klanten standaard op factuur met betalingstermijn.", icon: "ri-bank-card-line" },
    ],
  },
  onsTeam: {
    h2: "Ons team",
    p1: "Onze monteurs zijn ervaren vakmensen die elk minimaal 10 jaar in het vak zitten. Ze volgen regelmatig bijscholing om bij te blijven met nieuwe systemen — denk aan moderne SKG-sloten, elektrische Velux-motoren en de nieuwste generatie beslag.",
    p2: "Wij werken niet met onderaannemers. Onze monteurs zijn rechtstreeks bij ons in dienst en kennen Eindhoven als hun broekzak. Van Strijp-S tot Tongelre, van Woensel tot Stratum — wij vinden uw adres meteen.",
  },
  kerngegevens: {
    h2: "Onze kerngegevens",
    items: [
      { stat: "200+", label: "tevreden klanten in Eindhoven" },
      { stat: "10 jaar", label: "garantie op alle werken" },
      { stat: "Uitstekend", label: "Toonaangevende klantbeoordelingen op Google" },
      { stat: "7 dagen", label: "per week bereikbaar" },
    ],
  },
  werkwijze: {
    h2: "Hoe wij werken",
    steps: [
      { nr: "01", title: "Aanvraag", desc: "Bel of formulier, wij reageren binnen enkele uren" },
      { nr: "02", title: "Diagnose", desc: "Monteur komt gratis langs, eerlijke offerte op papier" },
      { nr: "03", title: "Reparatie", desc: "Vakkundig, originele onderdelen, vaak in 1 bezoek" },
      { nr: "04", title: "Garantie", desc: "Ondertekende garantieverklaring 10 jaar bij factuur" },
    ],
  },
  testimonials: {
    h2: "Klanten over ons",
    items: [
      { name: "Bart V.", area: "Strijp-S", text: "Schuifpui rollers vervangen binnen 2 dagen. Eerlijke prijs, nette afhandeling, geen discussie achteraf." },
      { name: "Linda H.", area: "Woensel-Noord", text: "Na inbraakpoging hele beslag van keukenraam vervangen in 2 uur. Vakwerk én snelheid." },
      { name: "VvE De Hofkamp", area: "Tongelre", text: "24 appartementen draaikiepramen afgesteld. Goede communicatie, duidelijke rapportage per woning." },
    ],
  },
  ctaBanner: {
    h2: "Klaar om uw raam te herstellen?",
    cta: "Bel 040 798 7470",
  },
};

export default nlWieZijnWij;